import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid g-0 content__space",
  style: {"min-width":"800px !important"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "card-text d-flex justify-content-start text-muted" }
const _hoisted_7 = { class: "container-fluid" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-4" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "container-fluid" }
const _hoisted_13 = {
  class: "col-12 d-flex",
  style: {"text-align":"left"}
}
const _hoisted_14 = { class: "col-4" }
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "container-fluid" }
const _hoisted_18 = {
  class: "col-12 d-flex",
  style: {"text-align":"left"}
}
const _hoisted_19 = { class: "col-4" }
const _hoisted_20 = { class: "card" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "container-fluid" }
const _hoisted_23 = {
  class: "col-12 d-flex",
  style: {"text-align":"left"}
}
const _hoisted_24 = { class: "card" }
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = { class: "container-fluid" }
const _hoisted_27 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_28 = ["href"]
const _hoisted_29 = {
  key: 0,
  class: "row"
}
const _hoisted_30 = { class: "col-12 d-flex justify-content-start" }
const _hoisted_31 = { class: "card-group" }
const _hoisted_32 = {
  key: 0,
  class: "card"
}
const _hoisted_33 = { class: "card-body" }
const _hoisted_34 = { class: "container-fluid" }
const _hoisted_35 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_36 = ["href"]
const _hoisted_37 = {
  key: 0,
  class: "row mt-4",
  style: {"min-height":"70px !important"}
}
const _hoisted_38 = { class: "col d-flex justify-content-start" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col" }
const _hoisted_41 = { class: "row centered mt-4" }
const _hoisted_42 = { class: "col-10 d-flex justify-content-end" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 0,
  class: "col saved"
}
const _hoisted_45 = {
  key: 1,
  class: "row mt-4"
}
const _hoisted_46 = { class: "col d-flex justify-content-center" }
const _hoisted_47 = { class: "form-signin" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col field__value" }
const _hoisted_50 = { style: {"font-weight":"bold","font-size":"1.4rem"} }
const _hoisted_51 = {
  key: 1,
  class: "card"
}
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = { class: "container-fluid" }
const _hoisted_54 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_55 = ["href"]
const _hoisted_56 = {
  key: 2,
  class: "card"
}
const _hoisted_57 = { class: "card-body" }
const _hoisted_58 = { class: "container-fluid" }
const _hoisted_59 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_60 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isData())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[43] || (_cache[43] = _createStaticVNode("<div class=\"container-fluid\" data-v-3ca09d41><div class=\"row\" style=\"min-height:130px;\" data-v-3ca09d41><div class=\"col-2\" data-v-3ca09d41><img src=\"img/icon/nettowin.png\" alt=\"NetToWin\" style=\"max-width:140px !important;\" data-v-3ca09d41></div><div class=\"col-8\" data-v-3ca09d41><p class=\"card-title\" data-v-3ca09d41><span style=\"font-size:24px;font-weight:bold;\" data-v-3ca09d41> SOS24Aid–144 </span> <br data-v-3ca09d41><span style=\"font-size:18px;font-weight:bold;\" data-v-3ca09d41> Kundeninformation / Informations pour les clients / Informazioni per i clienti </span></p></div><div class=\"col-2\" data-v-3ca09d41><img src=\"img/icon/sos24aid.png\" alt=\"Sos24-Aid\" style=\"max-width:100px !important;\" data-v-3ca09d41></div></div></div><p class=\"card-text\" style=\"min-height:6px !important;\" data-v-3ca09d41><small class=\"text-muted\" data-v-3ca09d41></small></p>", 2)),
                _createElementVNode("p", _hoisted_6, [
                  (!_ctx.isStandAlone)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onButtonCollapse && _ctx.onButtonCollapse(...args)), ["prevent"])),
                        class: "btn btn-outline-primary"
                      }, " Zuklappen "))
                    : _createCommentVNode("", true),
                  _createTextVNode("          Bereich / Zone / Zona:          " + _toDisplayString(_ctx.customer.info.bereichName), 1)
                ]),
                _cache[44] || (_cache[44] = _createElementVNode("p", { class: "card-text" }, [
                  _createElementVNode("small", { class: "text-muted" })
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "card-title" }, null, -1)),
                          _cache[16] || (_cache[16] = _createElementVNode("p", { class: "card-text" }, [
                            _createElementVNode("small", { class: "text-muted" }, "Hautpverantwortlich / Principal responsable (SiBe, COSEC)")
                          ], -1)),
                          _createElementVNode("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCustomerPeople('Kunde'), (item, id) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "row",
                                key: id
                              }, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createTextVNode(_toDisplayString(item.organisation) + " ", 1),
                                  _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.firma) + " ", 1),
                                  _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                                  _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.email) + " ", 1),
                                  _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.phone) + " ", 1),
                                  _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.cellPhone) + " ", 1),
                                  _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                                  _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.strasseMitHausnummer) + " ", 1),
                                  _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.pLzOrt) + " ", 1),
                                  _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.adresszusatz1) + " ", 1),
                                  _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.land) + " ", 1),
                                  _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1))
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _cache[28] || (_cache[28] = _createElementVNode("h5", { class: "card-title" }, null, -1)),
                          _cache[29] || (_cache[29] = _createElementVNode("p", { class: "card-text" }, [
                            _createElementVNode("small", { class: "text-muted" }, "Verantwortlich Technik / Responsable technologie")
                          ], -1)),
                          _createElementVNode("div", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCustomerPeople('Service'), (item, id) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "row",
                                key: id
                              }, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createTextVNode(_toDisplayString(item.organisation) + " ", 1),
                                  _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.firma) + " ", 1),
                                  _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                                  _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.email) + " ", 1),
                                  _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.phone) + " ", 1),
                                  _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.cellPhone) + " ", 1),
                                  _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                                  _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.strasseMitHausnummer) + " ", 1),
                                  _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.pLzOrt) + " ", 1),
                                  _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.adresszusatz1) + " ", 1),
                                  _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.land) + " ", 1),
                                  _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1))
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _cache[41] || (_cache[41] = _createElementVNode("h5", { class: "card-title" }, null, -1)),
                          _cache[42] || (_cache[42] = _createElementVNode("p", { class: "card-text" }, [
                            _createElementVNode("small", { class: "text-muted" }, "Rechnungskontakt / Contact de facturation")
                          ], -1)),
                          _createElementVNode("div", _hoisted_22, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCustomerPeople('Faktura'), (item, id) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "row",
                                key: id
                              }, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createTextVNode(_toDisplayString(item.organisation) + " ", 1),
                                  _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.firma) + " ", 1),
                                  _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                                  _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.email) + " ", 1),
                                  _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.phone) + " ", 1),
                                  _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.cellPhone) + " ", 1),
                                  _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                                  _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.strasseMitHausnummer) + " ", 1),
                                  _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.pLzOrt) + " ", 1),
                                  _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.adresszusatz1) + " ", 1),
                                  _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.land) + " ", 1),
                                  _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1))
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[45] || (_cache[45] = _createElementVNode("h5", { class: "card-title" }, "Ihre Rettungsdaten / Vos données de sauvetage / I tuoi dati di salvataggio", -1)),
                _cache[46] || (_cache[46] = _createElementVNode("p", { class: "card-text" }, null, -1)),
                _cache[47] || (_cache[47] = _createElementVNode("p", { class: "card-text" }, [
                  _createElementVNode("small", { class: "text-muted" })
                ], -1)),
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRettungsdaten(), (item, id) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      key: id
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("a", {
                          href: item.dokumentUrl,
                          target: "_blank"
                        }, _toDisplayString(_ctx.translateName( item.dokumentTyp ?? "" )) + " - " + _toDisplayString(item.datum), 9, _hoisted_28)
                      ])
                    ]))
                  }), 128)),
                  (!_ctx.isStandAlone && _ctx.isStandAlone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onRettungsdatenRefresh && _ctx.onRettungsdatenRefresh(...args)), ["prevent"])),
                            class: "btn btn-outline-primary mt-4"
                          }, " Rettungsdaten aktualisieren 1 ")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              (_ctx.isBestellAnforderung())
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _cache[52] || (_cache[52] = _createElementVNode("h5", { class: "card-title" }, "Ihre Bestellanforderung / Votre demande d'achat / La tua richiesta di acquisto", -1)),
                      _cache[53] || (_cache[53] = _createElementVNode("p", { class: "card-text" }, null, -1)),
                      _cache[54] || (_cache[54] = _createElementVNode("p", { class: "card-text" }, [
                        _createElementVNode("small", { class: "text-muted" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBestellanforderungen(), (item, id) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row",
                            key: id
                          }, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("a", {
                                href: item.dokumentUrl,
                                target: "_blank"
                              }, _toDisplayString(_ctx.translateName(item.dokumentTyp ?? "")), 9, _hoisted_36)
                            ])
                          ]))
                        }), 128)),
                        (_ctx.isBestellAnforderungEingabe())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("form", {
                                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.createCustomerBestellnummer()), ["prevent"])),
                                  class: "form-signin"
                                }, [
                                  _cache[49] || (_cache[49] = _createElementVNode("div", { class: "row" }, [
                                    _createElementVNode("div", { class: "col" }, [
                                      _createElementVNode("span", { style: {"white-space":"wrap","font-size":"0.9rem"} }, "Ihre Bestellnummer / Votre numéro de commande / Il tuo numero d'ordine")
                                    ])
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        id: "bestellNummer",
                                        class: "form-control",
                                        placeholder: "",
                                        autocomplete: "off",
                                        spellcheck: "false",
                                        autocorrect: "off",
                                        autocapitalize: "off",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bestellNummer) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.bestellNummer]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("div", _hoisted_42, [
                                      _createElementVNode("button", {
                                        disabled: _ctx.savedDisabled,
                                        class: "btn btn-primary form__button--view"
                                      }, "Nummer übermitteln / transmission / trasmettere", 8, _hoisted_43)
                                    ]),
                                    (_ctx.saved)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, _cache[48] || (_cache[48] = [
                                          _createElementVNode("img", {
                                            src: "img/icon/icons8-ok-48.png",
                                            alt: "Ok ..."
                                          }, null, -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 32)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.isBestellAnforderungEingabe())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("form", _hoisted_47, [
                                  _cache[51] || (_cache[51] = _createElementVNode("div", {
                                    class: "row",
                                    style: {"min-height":"30px"}
                                  }, [
                                    _createElementVNode("div", { class: "col" }, [
                                      _createElementVNode("span", { style: {"white-space":"wrap !important","font-size":"0.9rem"} }, "Ihre Bestellnummer / Votre numéro de commande / Il tuo numero d'ordine")
                                    ])
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.bestellNummer), 1)
                                    ]),
                                    _cache[50] || (_cache[50] = _createElementVNode("div", { class: "col-2" }, null, -1))
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isRechnung() && !_ctx.isReminder())
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _cache[55] || (_cache[55] = _createElementVNode("h5", { class: "card-title" }, "Ihre Rechnungen / Vos factures / Le tue fatture", -1)),
                      _cache[56] || (_cache[56] = _createElementVNode("p", { class: "card-text" }, null, -1)),
                      _cache[57] || (_cache[57] = _createElementVNode("p", { class: "card-text" }, [
                        _createElementVNode("small", { class: "text-muted" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_53, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInvoice(), (item, id) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row",
                            key: id
                          }, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("a", {
                                href: item.dokumentUrl,
                                target: "_blank"
                              }, _toDisplayString(_ctx.translateName(item.dokumentTyp ?? "")) + " " + _toDisplayString(item.bestellInformation), 9, _hoisted_55)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isReminder())
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _cache[58] || (_cache[58] = _createElementVNode("h5", { class: "card-title" }, "Mahnung zur Zahlung / Rappel de paiement / Promemoria di pagamento", -1)),
                      _cache[59] || (_cache[59] = _createElementVNode("p", { class: "card-text" }, null, -1)),
                      _cache[60] || (_cache[60] = _createElementVNode("p", { class: "card-text" }, [
                        _createElementVNode("small", { class: "text-muted" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_58, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getReminder(_ctx.customerLinks.documents), (item, id) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row",
                            key: id
                          }, [
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("a", {
                                href: item.dokumentUrl,
                                target: "_blank"
                              }, _toDisplayString(_ctx.translateName(item.dokumentTyp)) + " " + _toDisplayString(item.bestellInformation), 9, _hoisted_60)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}